import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import classNames from 'classnames/bind';

import Field from 'components/Field';
import { Row } from 'components/Grid';

import styles from './FieldComposition.module.css';

const cx = classNames.bind(styles);

export default class FieldComposition extends PureComponent {
  static propTypes = {
    disabled: PropTypes.bool,
    indent: PropTypes.bool,
    symbols: PropTypes.array,
    title: PropTypes.string,
    isLoggingEqualValues: PropTypes.bool,
  };

  static defaultProps = {
    disabled: false,
    indent: false,
    symbols: [],
    title: undefined,
    isLoggingEqualValues: false,
  };

  render() {
    const { title, indent, disabled, isLoggingEqualValues } = this.props;
    const symbolsList = this.props.symbols.map(item => (
      <div className={cx('field', {field_flex: item.labelStatic})} key={item.name}>
        <Field
          disabled={disabled}
          indent={indent}
          isLoggingEqualValues={item.name.indexOf('_percent') < 0 ? isLoggingEqualValues : false }
          {...item}
        />
      </div>
    ));

    return (
      <div className={cx('fieldComposition')}>
        <Row>
          <div className={cx('title')}>{title}</div>
          <div className={cx('container')}>
            {symbolsList}
          </div>
        </Row>
      </div>
    );
  }
}
